import React from 'react'
import CloseButton from "../../assets/images/galleryInner/Close Button.svg"
import ReactImageGallery from 'react-image-gallery';
import { useNavigate, useLocation } from 'react-router-dom';
const GalleryExternal = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { images } = location.state || {};
    const handleCancel = () => {
        if (location.state && location.state.from) {
            navigate(location.state.from);
        } else {
            navigate(-1);
        }
    };
    return (
        <div className='main-gallery-internal-bg-clr'>
            <div className='container'>
                {/* main-content-div */}
                <div className='main-content-div'>
                    {/* close-button-div */}
                    <div className='close-button-div'>
                        <img
                            onClick={() => {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                handleCancel();
                            }}
                            src={CloseButton} alt='CloseButton' />
                    </div>
                </div>
                <div>
                    <ReactImageGallery
                        items={images}
                        showFullscreenButton={false}
                        showBullets={false}
                        showPlayButton={false}
                    />
                </div>
            </div>
        </div>
    )
}

export default GalleryExternal